"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiDialogTitle = exports.MuiDialogContent = exports.MuiDialogActions = exports.MuiDialog = void 0;
exports.MuiDialog = {
    styleOverrides: {
        paper: {
            boxShadow: '0px 4px 14px rgba(0, 0, 0, 0.2), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14)',
        },
        paperWidthSm: {
            maxWidth: 684,
        },
        paperFullScreen: {
            maxWidth: 'none',
        },
    },
};
var dialogShadow = '0px 1px 10px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)';
exports.MuiDialogActions = {
    styleOverrides: {
        root: {
            justifyContent: 'center',
            padding: '14px 24px',
            '&.shadow': {
                boxShadow: dialogShadow,
            },
        },
    },
};
exports.MuiDialogContent = {
    styleOverrides: {
        root: {
            padding: '0px 24px',
        },
    },
};
exports.MuiDialogTitle = {
    styleOverrides: {
        root: {
            position: 'relative',
            zIndex: 1,
            '&.shadow': {
                boxShadow: dialogShadow,
            },
        },
    },
};
//# sourceMappingURL=MuiDialog.js.map